module.exports = __webpack_public_path__ + "media/elevadizo/buque-dd-3662c70f.png";